<template>
  <div>
    <!-- 部分开票弹框 -->
    <el-dialog title="部分开票" :visible="buFenKPMark" :close-on-click-modal="false" width="650px" center @close="closeDialog">
      <div class="addressBox">
        <div style="width:80%;margin:0 auto;">
          <el-form :inline="true" :rules="rules" :model="buFenKPFrom" ref="buFenKPFrom" class="demo-form-inline" label-width="130px" size="small">
            <el-form-item label="待开金额:">
              <span style="color:red;font-size:18px;margin-right:5px;">{{buFenKPFrom.pendingAmount}}</span><span>元</span>
            </el-form-item>
            <el-form-item label="开票金额:" prop="invoiceAmount">
              <el-input maxlength="10" v-model.trim="buFenKPFrom.invoiceAmount" v-number-input.float="2" style="width:230px;"></el-input>
            </el-form-item>
            <el-form-item label="发票号码:" prop="invoiceNo">
              <el-input placeholder="" maxlength="50" v-model.trim="buFenKPFrom.invoiceNo" style="width:230px;"></el-input>
            </el-form-item>
            <el-form-item label="开票时间:" prop="invoiceTime">
              <el-date-picker
                v-model="buFenKPFrom.invoiceTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="开票凭证:" v-if="buFenKPMark" >
              <uploadFiles style="width:300px;" :fileArr.sync='imgList' :max='1' @change='imgPreview' @remove='handleRemove' @handlePicPreview = 'handlePicPreview' v-if="buFenKPMark"></uploadFiles>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="buFenKPSubmitFn('buFenKPFrom')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { waySomeInvoiceForYs, waySomeInvoiceForYf } from '@/api/newTMS'
import uploadFiles from '@/views/newTMS/publicFiles/uploadFiles.vue'
export default {
  components: {
    uploadFiles
  },
  props: {
    buFenKPMark: {
      type: Boolean,
      default: false
    },
    buFenKPFrom: {
      type: Object,
      default: function () {
        return {}
      }
    },
    shouKuanFlag: {
      type: Boolean,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      imgList: [],
      rules: {
        invoiceTime: [
          { required: true, message: '请选择收开票时间', trigger: 'blur' }
        ],
        invoiceAmount: [
          { required: true, message: '请输入开票金额', trigger: 'blur' }
        ],
        invoiceNo: [
          { required: true, message: '请输入发票号码', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    console.log(this.buFenKPFrom, 'this.buFenKPFrom')
    this.$set(this.buFenKPFrom, 'invoiceAmount', '')
    this.$set(this.buFenKPFrom, 'invoiceNo', '')
    this.$set(this.buFenKPFrom, 'invoiceTime', '')
  },
  methods: {
    imgPreview (data) {
      // console.log('传', data)
      this.imgList = data
    },
    handleRemove (data) {
      console.log('data---', data)
    },
    handlePicPreview (file) {
      window.open(file.url)
    },
    closeDialog () {
      this.$emit('update:buFenKPMark', false)
      this.$refs.buFenKPFrom.resetFields()
    },
    buFenKPSubmitFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.buFenKPFrom.invoiceAmount > this.buFenKPFrom.pendingAmount) {
            this.$alert('开票金额必须小于待开金额', '系统提示')
            return
          }
          let imgfile = new FormData()
          if (this.imgList.length > 0) {
            for (var i = 0; i < this.imgList.length; i++) {
              let a = i
              imgfile.append('files', this.imgList[i].raw)
              if (a == this.imgList.length - 1) {
                imgfile.set('params', JSON.stringify(this.buFenKPFrom))
                if (this.shouKuanFlag) {
                  this.waySomeInvoiceYs(imgfile)
                } else {
                  this.waySomeInvoiceYf(imgfile)
                }
              }
            }
          } else {
            imgfile.set('params', JSON.stringify(this.buFenKPFrom))
            if (this.shouKuanFlag) {
              this.waySomeInvoiceYs(imgfile)
            } else {
              this.waySomeInvoiceYf(imgfile)
            }
          }
        } else {
          return false
        }
      })
    },
    // 应收-部分开票
    waySomeInvoiceYs (imgfile) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      waySomeInvoiceForYs(imgfile).then(res => {
        loading.close()
        this.$message({
          message: '成功',
          type: 'success'
        })
        this.$emit('update:buFenKPMark', false)
        this.$emit('refresh')
        this.$refs.buFenKPFrom.resetFields()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 应付-部分开票
    waySomeInvoiceYf (imgfile) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      waySomeInvoiceForYf(imgfile).then(res => {
        loading.close()
        this.$message({
          message: '成功',
          type: 'success'
        })
        this.$emit('update:buFenKPMark', false)
        this.$emit('refresh')
        this.$refs.buFenKPFrom.resetFields()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    }
  }
}
</script>
<style scoped>

</style>
